import uniqid from "uniqid";
import { skills } from "../../components/portfolio";
import "./Skills.css";

const resStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(6,8rem)",
    justifyContent: "center",
    gridGap: "20px",
    marginTop: "80px",
};

const Skills = () => {
  if (!skills.length) return null;

  return (
    <section id="skills">
      <h2 className="section__title" style={{ paddingTop: "40px" }}>
        Skills
      </h2>
      <div class="skills">
          {skills.map((el)=>{
            return(
              <div>
                <img src={el.icon} alt={el.title}/>
                <h3>{el.title}</h3>
              </div>
            )
          })}
      </div>
    </section>
  );
};

export default Skills;

//className="skills__list"
//className="section skills"





